import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";
import { useHistory } from "@/hooks/useHistory";
import { getMediaById } from "@/utils/media";

export default function MyLibraryMenu() {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState<"favorites" | "history">("favorites");
  const { favorites } = useFavorites();
  const { history } = useHistory();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const ids = tab === "favorites" ? favorites : history;
  const items = ids.map((id) => getMediaById(id)).filter(Boolean);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300/60 bg-background-100 px-3 text-sm text-foreground-800 transition-colors hover:border-primary-400/70 hover:text-foreground-950"
      >
        <i className="ri-bookmark-line text-base"></i>
        <span className="hidden sm:inline">我的收藏</span>
        {favorites.length > 0 && (
          <span className="flex h-5 min-w-[20px] items-center justify-center rounded-full bg-accent-500 px-1 text-xs font-semibold text-background-50">
            {favorites.length}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-80 rounded-lg border border-background-300/60 bg-background-100 p-3 shadow-xl">
          <div className="flex items-center rounded-full bg-background-200/70 p-1">
            <button
              type="button"
              onClick={() => setTab("favorites")}
              className={`flex-1 whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                tab === "favorites"
                  ? "bg-primary-500 text-foreground-950"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              收藏 ({favorites.length})
            </button>
            <button
              type="button"
              onClick={() => setTab("history")}
              className={`flex-1 whitespace-nowrap rounded-full px-3 py-1.5 text-sm transition-colors ${
                tab === "history"
                  ? "bg-primary-500 text-foreground-950"
                  : "text-foreground-600 hover:text-foreground-950"
              }`}
            >
              浏览记录 ({history.length})
            </button>
          </div>

          <div className="mt-3 max-h-72 space-y-1 overflow-y-auto">
            {items.length === 0 ? (
              <p className="py-8 text-center text-sm text-foreground-500">
                {tab === "favorites"
                  ? "还没有收藏任何影视"
                  : "还没有浏览记录"}
              </p>
            ) : (
              items.map((item) =>
                item ? (
                  <Link
                    key={item.id}
                    to={`/detail/${item.id}`}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-3 rounded-md p-2 transition-colors hover:bg-background-200/70"
                  >
                    <img
                      src={item.cover}
                      alt={item.title}
                      className="h-14 w-10 shrink-0 rounded object-cover object-top"
                    />
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-medium text-foreground-950">
                        {item.title}
                      </p>
                      <p className="truncate text-xs text-foreground-500">
                        {item.year} · {item.genre.slice(0, 2).join(" ")}
                      </p>
                    </div>
                  </Link>
                ) : null
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
}